import { render, staticRenderFns } from "./greeting.popup-chunk.vue?vue&type=template&id=35afa9e0&scoped=true"
import script from "./greeting.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./greeting.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./greeting.popup-chunk.vue?vue&type=style&index=0&id=35afa9e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35afa9e0",
  null
  
)

export default component.exports